import React, { useState, useEffect } from "react";

import UserService from "../Services/user.service";
import AuthService from "../Services/auth.service";

import TbUserTrainSess from '../components/TbUserTrainSess/table';
import Mainmenu from '../components/MainMenu/mainmenu';

const BoardUser = () => {
  const [content, setContent] = useState("");
  
  useEffect(() => {
    UserService.getUserBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);
  

  const user=AuthService.getCurrentUser();
  const spazio=" ";

  return (
    <div className="container">
      <header className="">        
        {/*<h6>{user.username}{spazio}{content}{user.usercode}</h6>*/}
        {/*<TbUserTrainSess/>*/}
        <Mainmenu/>
      </header>
    </div>
  );
};

export default BoardUser;
